<ng-template let-data #confirmTmp>
  <h1 mat-dialog-title>{{ data.title || 'Are you sure?' }}</h1>

  @if (data.body || data.bodyText) {
  <div mat-dialog-content>
    @if (data.body) {
    <ng-container [ngTemplateOutlet]="data.body"></ng-container>
    } @if (data.bodyText) {
    <span>{{ data.bodyText }}</span>
    } @if (!!data.validator && !!data.validator()) {
    <p class="form-error-msg">
      {{ data.validator() }}
    </p>
    }
  </div>
  }

  <div mat-dialog-actions>
    @if (!data.hideClose) {
    <button mat-flat-button color="secondary" [mat-dialog-close]>
      {{ data.cancelText || 'No' }}
    </button>
    }
    <button
      mat-flat-button
      color="primary"
      [disabled]="!!data.validator && !!data.validator()"
      [mat-dialog-close]="true"
      cdkFocusInitial>
      {{ data.confirmText || 'Ok' }}
    </button>
  </div>
</ng-template>
